import { Release } from '@common/types/release/release';

export const newRelease = (): Partial<Release> => {
  return {
    type: 'single',
    status: 'draft',
    releaseHistory: 'new',
    isExplicit: false,
    hasPreorder: false,
    removeBranding: undefined,
    albumPrice: 9.99,
    stores: [],
    regions: []
  }
}